import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, Global } from "@mantine/core";
import App from "./App";
import "./index.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      fontFamily: "'Poppins', sans-serif",
      primaryColor: "brand",
      colors: {
        brand: [
          "#fff5f5",
          "#ffe3e3",
          "#ffc9c9",
          "#ffa8a8",
          "#ff8787",
          "#ff6b6b",
          "#fa5252",
          "#f03e3e",
          "#e03131",
          "#c92a2a",
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: "#ffffff",
          fontFamily: "'Poppins', sans-serif",
        },
      }}
    />

    <App />
  </MantineProvider>
);
